import axiosInstance from '@/plugins/axios';

// Dashboard Afastamento e inatividade (S-2230) — porte do CollaboratorController (BFF).
const ServiceAfastamento = {
  dashboard: (body) => axiosInstance.post('collaborator/dashboard/active-and-retired', body ?? {}),
  filters: (rootCnpjList) =>
    axiosInstance.post('collaborator/dashboard/filters', rootCnpjList ?? null),
  /**
   * @param {*} body
   * @param {{ page?: number, size?: number, sort?: string }} [opts]
   **/
  history: (body, { page = 0, size = 50, sort } = {}) =>
    axiosInstance.post('collaborator/history/active-and-retired', body ?? {}, {
      params: { page, size, ...(sort ? { sort } : {}) },
    }),
  // Export: enfileira um export persistido (report_process) — não retorna mais binário.
  exportData: (body) =>
    axiosInstance.post('collaborator/history/active-and-retired/export', body ?? {}),
};

export default ServiceAfastamento;
